import PageTransition from '../components/PageTransition';
import AboutBlock from "../components/AboutBlock";
import Reviews from "../components/Reviews";
import Why from "../components/Why";
import Process from "../components/Process";
import FAQ from "../components/FAQ";
import Alts from "../components/Alts";

export default function About(){
    return (
        <PageTransition keyId="about">


            <AboutBlock />

            <Process />

            <Alts />

            <FAQ />

            <Reviews />

            <div style={{height: '100px'}}>

            </div>



        </PageTransition>
    );
}
